import Container from '@components/global/Container';
import Heading from '@components/ui/Heading';
import { GridIcon, PageType } from '@adapters/prismic/types/slices';
import IconGridItem from './IconGridItem';

import styles from './IconGrid.module.scss';

const IconGrid = ({
  title,
  items,
  trackPromos,
  pageType,
  sliceIndex,
}: {
  title: string;
  items: GridIcon[];
  trackPromos: boolean;
  pageType: PageType;
  sliceIndex: number;
}) => (
  <Container>
    <Heading
      semanticLevel="h2"
      styleLevel="2"
      className={styles.iconGridHeading}
    >
      {title}
    </Heading>
    <div className={styles.iconGridContainer}>
      {items.map(({ image, link }, i) => (
        <IconGridItem
          key={(image.alt || link) + i}
          image={image}
          link={link}
          positionWithinSlice={i}
          trackPromos={trackPromos}
          pageType={pageType}
          sliceIndex={sliceIndex}
        />
      ))}
    </div>
  </Container>
);

export default IconGrid;
